import { useGetFrontCategorie } from '@framework/api-client';
import { useMemo } from 'react';

/**
 * Custom hook per recuperare l'etichetta di una categoria dato il suo ID
 */
export function useFetchCategoryLabel(categoryId?: string | null) {
  // Non avendo l'API per una singola categoria, recuperiamo tutte le categorie
  // e filtriamo in locale
  const { data: categoryData, isLoading } = useGetFrontCategorie(
    {},
    { query: { enabled: categoryId != null } },
  );

  // Memoizziamo il calcolo dell'etichetta della categoria
  const categoryLabel = useMemo(() => {
    if (!categoryId) return null;
    return (
      categoryData?.dati?.find(category => String(category.id) === categoryId)
        ?.etichetta ?? null
    );
  }, [categoryData?.dati, categoryId]);

  return { categoryLabel, isLoading };
}
